module.exports = __webpack_public_path__ + "img/momo_wrong.b0aef1f4.png";